// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'book-open';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M13.5 3.105c1.173-.19 2.36-.287 3.547-.292a.406.406 0 0 1 .278.105.382.382 0 0 1 .113.27V15a.382.382 0 0 1-.375.375C10.845 15.465 9 17.438 9 17.438m0 0V4.86S7.163 2.895.953 2.813a.412.412 0 0 0-.278.105.382.382 0 0 0-.112.27V15a.382.382 0 0 0 .375.375C7.155 15.465 9 17.438 9 17.438z' />
    <path d='M9 17.07a4.5 4.5 0 0 1 1.23-2.587 6.135 6.135 0 0 1 3.27-1.845V.93a.345.345 0 0 0-.172-.3.45.45 0 0 0-.368-.045 5.83 5.83 0 0 0-2.73 1.703A4.65 4.65 0 0 0 9 4.86' />
  </g>
);

export const viewBox = '0 0 18 18';
